(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["colony_youtube"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tbm-video-cover')) {
    customElements.define('tbm-video-cover', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.playVideo);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.playVideo);
      }
      playVideo(event) {
        const link = event.target.closest('.tbm-video-cover__poster');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const player = document.createElement('iframe');
        player.src = 'https://www.youtube.com/embed/' + encodeURIComponent(this.dataset.videoId) + '?autoplay=1&playsinline=1';
        player.title = this.dataset.videoTitle;
        player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        player.allowFullscreen = true;
        player.tabIndex = 0;
        this.replaceChildren(player);
        player.focus();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
